const AboutBlock = () => (
  <section id="about" className="w-full overflow-hidden">
    {/* Full-bleed image with text overlay */}
    <div className="relative min-h-[88vh] flex items-end">
      <div className="absolute inset-0">
        {/* Real image from debsartdesigns.com */}
        <img
          src="https://images.squarespace-cdn.com/content/v1/6205743531e70503b4cb51e0/21a6f67e-20ce-43ba-bef6-b28936fce2eb/3V9A0070.jpg"
          alt="Deb's Art Designs original artwork"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1612]/80 via-[#1A1612]/45 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1612]/85 via-transparent to-[#1A1612]/15"></div>
      </div>

      {/* Content — bottom left, text over image */}
      <div className="relative z-10 w-full px-8 md:px-16 lg:px-24 xl:px-32 pb-20 pt-44">
        <div className="max-w-2xl">
          <div className="flex items-center gap-5 mb-10">
            <div className="w-16 h-px bg-[#C9A96E]/60"></div>
            <span className="text-[#C9A96E]/70 uppercase tracking-[0.5em] text-[9px] font-light">About the Studio</span>
          </div>

          <h2 className="font-serif text-white leading-[0.9] tracking-[-0.01em] mb-10" style={{ fontSize: 'clamp(2.8rem, 6vw, 5.5rem)', fontWeight: 300 }}>
            Art That Tells<br />
            <em className="italic text-[#D4B483]" style={{ fontWeight: 300 }}>Your Story</em>
          </h2>

          <p className="text-white/60 text-sm leading-[2.1] tracking-[0.05em] font-light max-w-lg mb-12">
            Deb&apos;s Art Designs is a custom art studio specializing in original, hand-created artwork tailored to each client&apos;s vision. Every piece is uniquely crafted — no duplication, no mass production. The studio works closely with you from the first idea through to the finished work.
          </p>

          <div className="flex flex-col sm:flex-row gap-10 mb-14">
            {[
              { value: '100%', label: 'Original' },
              { value: 'Zero', label: 'Mass Production' },
              { value: 'Every', label: 'Piece Unique' },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col gap-1">
                <span className="font-serif text-[#D4B483] text-3xl" style={{ fontWeight: 300 }}>{stat.value}</span>
                <span className="text-white/35 text-[10px] uppercase tracking-[0.4em] font-light">{stat.label}</span>
              </div>
            ))}
          </div>

          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="whitespace-nowrap flex items-center gap-5 text-white/45 text-[10px] font-light uppercase tracking-[0.5em] hover:text-[#C9A96E] transition-all duration-500 cursor-pointer group"
          >
            Begin Your Project
            <div className="w-10 h-px bg-white/25 group-hover:bg-[#C9A96E]/60 group-hover:w-16 transition-all duration-500"></div>
          </button>
        </div>
      </div>
    </div>

    {/* Below: light editorial strip */}
    <div className="bg-[#FAF7F3] px-8 md:px-16 lg:px-24 xl:px-32 py-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-20">
        {[
          {
            icon: 'ri-brush-2-line',
            title: 'Custom Art & Commissions',
            body: 'Original pieces created entirely around your vision — your colors, your mood, your story. No templates, no shortcuts.',
          },
          {
            icon: 'ri-sparkling-line',
            title: 'Completely Unique',
            body: 'Every work is conceived and created exclusively for you. Once made, it will never be duplicated or reproduced.',
          },
          {
            icon: 'ri-user-heart-line',
            title: 'Tailored to You',
            body: 'Your style, your space, your expression — built into every decision from the very first conversation.',
          },
        ].map((f) => (
          <div key={f.title} className="flex flex-col gap-5">
            <div className="w-8 h-8 flex items-center justify-center text-[#C9A96E]/70">
              <i className={`${f.icon} text-lg`}></i>
            </div>
            <h3 className="font-serif text-[#1A1612]/75 text-xl" style={{ fontWeight: 400 }}>{f.title}</h3>
            <div className="w-8 h-px bg-[#C9A96E]/40"></div>
            <p className="text-[#1A1612]/45 text-sm leading-[2] tracking-[0.04em] font-light">{f.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default AboutBlock;
